module.exports = __webpack_public_path__ + "img/gley.03bdea96.svg";